export const getToken = () => localStorage.getItem("BETTY_ADMIN_USER_TOKEN");
